
export const sendSlackMessage= async (message) =>{
  try {
    const res = await fetch(`${process.env.VUE_APP_API_URL}/send/slack-message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ text: message })
    });

    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }

    const data = await res.json();
    return data; // { success: true, message: "Message sent to Slack!" }
  } catch (error) {
    console.error("Slack error:", error);
    return { success: false, error: error.message };
  }
}

